import Updating from './Updating';

export default Updating;
